<template>
	<div id="login" data-am-scrollspy="{animation: 'fade'}">
		<div class="login_bg">
			<div class="header" data-am-scrollspy="{animation: 'fade', delay: 300}">
                <div class="container flex bCenter middle">
                    <div class="logo">
                        <img @click="clickLogo" class="cursorPointer" src="@/assets/images/general/header_logo.png" alt="">
                    </div>
                    <!-- <ul>
                        <li>
                            <img src="@/assets/images/login/pc_01.png" alt="">
                            <el-link :underline="false">在线培训</el-link>
                        </li>
                    </ul> -->
                </div>
			</div>

			<div class="box flex middle center">
                <div id="box_left" class="box_left" data-am-scrollspy="{animation: 'slide-left', delay: 300}">
                    <div>
                        <img src="@/assets/images/login/logo.png" alt="">
                    </div>
                    <p>团餐食品安全管理平台</p>
                </div>
                <div id="box_right" class="box_right" data-am-scrollspy="{animation: 'slide-right', delay: 300}">
                    <!-- 登录 -->
                    <div class="login" v-if="pageSwitch === 'login'">
                        <div class="code">
                            <img src="@/assets/images/login/pc_02.png" alt="">
                        </div>
                        <div class="login_box flex column bCenter">
                            <h3><span>登录</span></h3>
                            <div class="login_form">
                                <el-form ref="loginForm" :model="form" :rules="rules" status-icon>
                                    <el-form-item prop="userName">
                                        <el-input v-model="form.userName" placeholder="请输入账户名">
                                            <template slot="prepend">
                                                <img src="@/assets/images/login/pc_03.png" alt="">
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="passWord">
                                        <el-input type="password" v-model="form.passWord" placeholder="请输入密码">
                                            <template slot="prepend">
                                                <img src="@/assets/images/login/pc_04.png" alt="">
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <!-- <div class="options flex middle bCenter">
                                    <el-link :underline="false">用户注册</el-link>
                                    <el-link :underline="false">忘记密码？</el-link>
                                </div> -->
                            </div>
                            <div class="button">
                                <el-button :loading="isSending" @click="submit">登录</el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 注册 -->
                    <div class="regist" v-else-if="pageSwitch === 'regist'"></div>
                    <!-- 忘记密码 -->
                    <div class="forget" v-else-if="pageSwitch === 'forget'"></div>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'

/* 定义所有表单的校验规则 */
const formRules = {
    userName: [{
        required: true,
        message: '请输入账户名',
        trigger: 'blur'
    }],
    passWord: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
    }],
}
export default {

	data() {
		return {
            pageSwitch: 'login', // login-登录，regist-注册，forget-忘记密码
            isSending: false, // 是否正在提交表单
            form: {
                userName: '',
                passWord: '',
            },
            rules: {
                userName: formRules.userName, 
                passWord: formRules.passWord,
            },
		}
    },
    created() {
    },
    mounted(){
        require ("utils/js/amazeui.js");
        this.scrollspyListening();
    },
    methods: {
        scrollspyListening(){
			$('[data-am-scrollspy]').scrollspy();

			if($('#box_left')){
				$('#box_left').on('inview.scrollspy.amui', function() {
					// console.log('进入视口：',$('#my-scrollspy-part2-2').manualShow);
					if($('#box_right')){
						$('#box_right').manualShow();
					}
				}).on('outview.scrollspy.amui', function() {
					// console.log('离开视口');
					if($('#box_right')){
						$('#box_right').manualHide();
					}
				});
			}
		},

        clickLogo(){//首页
            this.$router.push({path:"/"});
        },

        /* 提交表单验证 */
        submit() {
            this.$refs[`${this.pageSwitch}Form`].validate((valid) => {
                if (valid) {
                    this[this.pageSwitch]();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        /* 登录 */
        async login() {
            this.isSending = true;
            // let res = await api();
            // if(res.status == 200) {

            // } 
            // this.isSending = false;
        },
    }
}
</script>

<style lang="less" scoped>
@import '~utils/css/amazeui.css';
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
@import './index.less';
</style>
